import { render, staticRenderFns } from "./MoreInfo.vue?vue&type=template&id=5c2375a0&scoped=true"
import script from "./MoreInfo.vue?vue&type=script&lang=js"
export * from "./MoreInfo.vue?vue&type=script&lang=js"
import style0 from "./MoreInfo.vue?vue&type=style&index=0&id=5c2375a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2375a0",
  null
  
)

export default component.exports